import { GenerateProductSeoTagsBrandResponseDto } from '@tiendanube/common';
import { LanguageInterface } from 'App/i18n';
import { AIGenerated } from 'domains/Catalog/Products/productsSlice';

export const mergeSeoParametersWithAI = (
  seo: GenerateProductSeoTagsBrandResponseDto['seo'],
  currentSeoTitle: LanguageInterface,
  currentSeoDescription: LanguageInterface,
  currentGeneratedAI: AIGenerated,
) => {
  const titles = { ...currentSeoTitle };
  const descriptions = { ...currentSeoDescription };
  const titlesGenerated = { ...currentGeneratedAI.seoTitle };
  const descriptionsGenerated = { ...currentGeneratedAI.seoDescription };

  for (const { language, title, description } of seo) {
    if ((currentSeoTitle[language] ?? '') === '') {
      titles[language] = title;
      titlesGenerated[language] = true;
    }
    if ((currentSeoDescription[language] ?? '') === '') {
      descriptions[language] = description;
      descriptionsGenerated[language] = true;
    }
  }

  return { titles, descriptions, titlesGenerated, descriptionsGenerated };
};
